import { Upload, Image } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';

const FooterPreview = ({
    fileList,
    setFileList,
    handlePreview,
    handleChange,
    handleFileUpload,
    accept,
    uploading,
    previewOpen,
    previewImage,
    setPreviewOpen,
    setPreviewImage,
    pendingVoice
}) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    if (fileList.length === 0 || pendingVoice) return null;

    return (
        <>
            <div style={{ marginBottom: '12px', width: '100%' }}>
                <div style={{ overflowX: 'auto', overflowY: 'hidden', padding: '4px', WebkitOverflowScrolling: 'touch' }}>
                    <div style={{ display: 'inline-flex', gap: '8px', paddingBottom: '10px' }}>
                        {fileList.map((file) => (
                            <div key={file.uid} style={{ width: '104px', height: '104px', flexShrink: 0 }}>
                                <Upload
                                    listType="picture-card"
                                    fileList={[file]}
                                    onPreview={() => handlePreview(file)}
                                    onChange={(info) => handleChange(info, file)}
                                    showUploadList={{
                                        showPreviewIcon: true,
                                        showRemoveIcon: true,
                                        showDownloadIcon: false,
                                    }}
                                    style={{ width: '104px', height: '104px' }}
                                />
                            </div>
                        ))}
                        {fileList.length < 8 && (
                            <div style={{ width: '104px', height: '104px', flexShrink: 0 }}>
                                <div className="ant-upload-select" style={{ width: '100%', height: '100%' }}>
                                    <Upload
                                        accept={accept || undefined}
                                        multiple
                                        showUploadList={false}
                                        beforeUpload={async (file) => {
                                            const uploadedFile = await handleFileUpload(file);
                                            if (uploadedFile) {
                                                setFileList((prev) => [...prev, uploadedFile]);
                                            }
                                            return false;
                                        }}
                                    >
                                        <div style={{
                                            width: '104px',
                                            height: '104px',
                                            border: `1px dashed ${isDarkMode ? '#434343' : '#d9d9d9'}`,
                                            borderRadius: '8px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: uploading ? 'not-allowed' : 'pointer',
                                            backgroundColor: isDarkMode ? '#2a2a2a' : undefined
                                        }}>
                                            {uploading ? (
                                                <LoadingOutlined style={{ color: isDarkMode ? '#fff' : undefined }} />
                                            ) : (
                                                <>
                                                    <PlusOutlined style={{ color: isDarkMode ? '#fff' : undefined }} />
                                                    <div style={{ marginTop: 8, color: isDarkMode ? '#fff' : undefined }}>{t('upload')}</div>
                                                </>
                                            )}
                                        </div>
                                    </Upload>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
};

export default FooterPreview;
